/** This file is auto generated by convertSvgToJsx.ts */

import React from 'react'
const fish_medium = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M11.8 3.555c-3.173.016-6.3 1.62-7.362 3.8-.253.56-.125 1.22.319 1.645L7.3 11.541m2.58 5.726c8.57-1.513 14.233-5.933 13.261-15.125A1.458 1.458 0 0 0 21.858.858C12.666-.114 8.246 5.55 6.733 14.12m3.147 3.147-2.483 5.57a.742.742 0 0 1-1.367-.1l-.87-3.9-3.9-.87a.742.742 0 0 1-.1-1.367l5.573-2.48m3.147 3.147L6.733 14.12m13.712-1.92c-.016 3.173-1.62 6.3-3.8 7.362a1.45 1.45 0 0 1-1.645-.32L12.462 16.7m5.163-13.2a1.125 1.125 0 1 1 0 2.25 1.125 1.125 0 0 1 0-2.25Z"
    />
  </svg>
)
export default fish_medium
